import React from 'react';
import { CardContent } from '@mui/material';
import { styled } from '@mui/system';


// Style wrapper for article-like formatting
const ContentWrapper = styled('div')(({ theme }) => ({
    '& h1, h2, h3': {
      marginTop: theme.spacing(3),
      marginBottom: theme.spacing(1.5),
      fontWeight: 600,
    },
    '& p': {
      marginBottom: theme.spacing(2),
      lineHeight: 1.7,
      fontSize: '1.1rem',
    },
    '& ul, ol': {
      marginLeft: theme.spacing(3),
      marginBottom: theme.spacing(2),
    },
    '& img': {
      maxWidth: '100%',
      margin: theme.spacing(2, 0),
      borderRadius: '8px',
    },
    '& blockquote': {
      fontStyle: 'italic',
      borderLeft: `4px solid ${theme.palette.primary.main}`,
      paddingLeft: theme.spacing(2),
      margin: theme.spacing(2, 0),
      color: theme.palette.text.secondary,
    },
  }));
function ArticleViewer(props) {
  const raw = props.contentJson ?? props.content ?? '';
  let htmlContent = '';

  if (typeof raw === 'string' && raw.trim().length) {
    // Content may be stored either as raw HTML or as a JSON envelope { "html": "..." }.
    const trimmed = raw.trim();
    if (trimmed.startsWith('{')) {
      try {
        const parsed = JSON.parse(trimmed);
        htmlContent = parsed?.html || '';
      } catch (e) {
        htmlContent = raw;
      }
    } else {
      htmlContent = raw;
    }
  }

  
  return (
    
      <CardContent>
        <ContentWrapper dangerouslySetInnerHTML={{ __html: htmlContent }} />
       
      </CardContent>
   
  );
}

export default ArticleViewer;
